import { render, staticRenderFns } from "./SelectAreaModal.vue?vue&type=template&id=6543a3e4&"
import script from "./SelectAreaModal.vue?vue&type=script&lang=js&"
export * from "./SelectAreaModal.vue?vue&type=script&lang=js&"
import style0 from "./SelectAreaModal.vue?vue&type=style&index=0&id=6543a3e4&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports